export default {
    general: {
        name: 'Nom',
        email: 'E-mail',
        description: 'Description',
        status: 'Statut',
        date: 'Date',
        id: 'ID',
        size: 'Taille',
        add: 'Ajouter',
        data: 'Les données',
        more_info: 'Plus d\'informations',
        all: 'Tous',
        clear_filters: 'Effacer les filtres',
        expand_columns: 'Développer les colonnes',
        filter_mode: 'Mode de filtre',
        filter_contains: 'Contient',
        filter_not_contains: 'Ne contient pas',
        filter_equals: 'Égal à',
        filter_not_equals: 'Différent de',
        filter_starts_with: 'Commence par',
        filter_ends_with: 'Se termine par',
        filter_less_than: 'Inférieur à',
        filter_less_than_or_equal: 'Inférieur ou égal à',
        filter_greater_than: 'Supérieur à',
        filter_greater_than_or_equal: 'Supérieur ou égal à',
        filter_in_range: 'Dans la plage',
        filter_before: 'Avant',
        filter_after: 'Après',
        filter_from: 'De',
        filter_to: 'À',
        reload: 'Recharger',
        reset_column_widths: 'Réinitialiser les largeurs de colonnes',
        resize_column: 'Redimensionner la colonne',
        search: 'Rechercher',
        yes: 'Oui',
        no: 'Non',
        list: 'Liste',
        download: 'Télécharger',
        approve: 'Approuver',
    },
    nav: {
        tasks: 'Tâches',
        projects: 'Projets',
        invoices: 'Factures',
        submit_request: 'Envoyer la demande',
        logout: 'Se déconnecter',
    },
    task: {
        list_open: 'Ouvert',
        list_in_confirmation: 'En Confirmation',
        list_finished: 'Fini',
        status_unassigned: 'Non attribué',
        status_open: 'Ouvert',
        status_in_progress: 'En cours',
        status_waiting: 'Attendre',
        status_sent_for_confirmation: 'Envoyé pour confirmation',
        status_confirmed: 'Confirmé',
        status_invoiced: 'Facturé',
        denied_letter: 'D',
        title: 'Titre de la tâche',
        branch_office: 'Succursale',
        assigned_user: 'Utilisateur affecté',
        added: 'Ajouté',
        deadline: 'Date limite',
        contact: 'Contact',
        adding_failed: 'Échec de l\'ajout de la demande',
    },
    project: {
        leader: 'Chef de projet',
        total_tasks: 'Tâches totales',
        finished_tasks: 'Tâches terminées',
        completed: 'Terminé',
        offer_id: 'ID de l\'offre',
        waiting_for_leader: 'En attente de la confirmation du chef de projet',
        waiting_for_client: 'En attente de la confirmation du client',
        finished: 'Projet terminé',
        denial_reason: 'Raison du refus:',
    },
    invoice: {
        number_of_tasks: 'Nombre de tâches',
        invoice_file: 'Facture d\'achat',
        times: 'Temps',
        transport: 'Transport',
        transport_names: 'Types de transport',
        kilometers: 'Kilomètres',
        total_time: 'Temps total',
        task_ids: 'ID de tâche',
        files: 'Fichiers',
        finished: 'Terminé',
        approved_by: 'Approuvé par',
        open_printout: 'Impression ouverte',
    },
    client: {
        select: 'Client',
        change_failed: 'Échec du changement',
    },
    login: {
        title: 'S\'identifier',
        subtitle: 'Bienvenue à nouveau, veuillez vous connecter à votre compte.',
        password: 'Mot de passe',
        forgot_password: 'Mot de passe oublié?',
        submit: 'S\'identifier',
        failed: 'Échec de la connexion',
        language: 'Langue',
        reset_password: 'Réinitialiser le mot de passe',
        send_reset_mail: 'Envoyer une demande',
        reset_text: 'Un mail avec lien et instructions vous a été envoyé!',
        password_reset_success: 'Le mot de passe a été changé avec succès',
        new_password: 'Nouveau mot de passe',
        reset_mail_already_sent: 'L\'e-mail de réinitialisation a déjà été envoyé',
        back_to_login: 'Retour à la connexion',
    },
    register: {
        title: 'S\'inscrire',
        last_name: 'Nom de famille',
        confirm_password: 'Confirmez le mot de passe',
        verification_sent: 'Un e-mail de vérification a été envoyé!',
        failed: 'Échec de l\'inscription',
    },
    confirm_mail: {
        title: 'Confirmation de l\'émail',
        confirmed: 'L\'adresse e-mail a été confirmée avec succès!',
        failed: 'L\'adresse e-mail n\'a pas pu être confirmée!',
    },
    errors: {
        generic_error: 'Une erreur est survenue',
        invalid_data: 'Données invalides',
        not_found: 'Introuvable',
        on_add: 'Erreur lors de l\'ajout',
        on_edit: 'Erreur lors de la mise à jour',
        unauthorized: 'Non autorisé',
        page_not_found: 'Page introuvable',
        back_home: 'Retour à l\'accueil',
    },
    success: {
        add: 'Ajouté avec succès',
        edit: 'Mis à jour avec succès',
    },
    validation: {
        required: 'Ce champ est obligatoire',
        email: 'Adresse e-mail invalide',
    },
    brand: {
        product_name: 'ITOMS',
    },
    layout: {
        open_menu: 'Ouvrir le menu',
        close_menu: 'Fermer le menu',
    },
    color_mode: {
        switch_to_light: 'Passer en mode clair',
        switch_to_dark: 'Passer en mode sombre',
    },
}
